import { createFileRoute } from '@tanstack/react-router';
import { ContasReceber } from '@/features/contas-receber/page';

export const Route = createFileRoute('/a/contas-receber/')({
    component: ContasReceber,
});
